
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 22","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16.474.268v11l-2.737-4.936L11 11.322 8.368 6.063l-2.736 5.205-2.685-5.205-2.684 5.205.053 10.464h19.421V.268z","fill":"#231F20","fill-rule":"nonzero"}})])
          )
        }
      }
    